var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useCallback, useState } from 'react';
import { styled } from '@mui/system';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { CarouselTrack } from './CarouselTrack';
export var Carousel = function (_a) {
    var children = _a.children, autoPlay = _a.autoPlay, interval = _a.interval, loop = _a.loop, _b = _a.itemsPerPage, itemsPerPage = _b === void 0 ? 1 : _b, rest = __rest(_a, ["children", "autoPlay", "interval", "loop", "itemsPerPage"]);
    var _c = useState(0), index = _c[0], setIndex = _c[1];
    var childCount = Children.count(children);
    var handleNext = useCallback(function (step) {
        if (step === void 0) { step = 1; }
        var idx = loop ? 0 : index;
        setIndex(index + step === childCount ? idx : index + step);
    }, [childCount, index, loop]);
    var handlePrev = useCallback(function (step) {
        if (step === void 0) { step = 1; }
        var idx = loop ? childCount - step : 0;
        setIndex(index - step < 0 ? idx : index - step);
    }, [childCount, index, loop]);
    return (_jsxs(Wrapper, __assign({}, rest, { children: [_jsx(Arrow, __assign({ onClick: function () { return handlePrev(); } }, { children: _jsx(BsChevronLeft, { size: "1.75rem" }) })), _jsx(CarouselTrack, __assign({ itemsPerPage: itemsPerPage, autoPlay: autoPlay, interval: interval, loop: loop, index: index, handlePrev: handlePrev, handleNext: handleNext }, { children: children })), _jsx(Arrow, __assign({ onClick: function () { return handleNext(); } }, { children: _jsx(BsChevronRight, { size: "1.75rem" }) }))] })));
};
var Wrapper = styled('div')({
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '1.5rem auto 1.5rem',
});
var Arrow = styled('div')({
    userSelect: 'none',
    paddingTop: '1rem',
});
